import { MasterTask } from "./index";

export class TaskCategory {
    masterTaskListCategoryId: number;
    masterTaskListCategoryName: string;
    masterTaskList: MasterTask[];
    isActive: boolean;
}
